import jQuery from 'jquery';
let $ = jQuery;
import __extends from 'LIBS/extend.js';
import YoutubePlayer from 'HSNDIR/Widget/VideoPlayers/YoutubePlayer.js';
import "LIBS/jquery.showhtml.js";
// Desktop/Mobile split... Use Globally available HSN.Modal
//import "HSNDIR/Modal.js";

/**
* class HSN.YoutubeModal
* Encapsulates the functionality of a youtube video dialog using youtube js api
**/
HSN.YoutubeModal = (function(parent) {
    __extends(YoutubeModal, parent);
        
    var youtubePlayer = null;

    function YoutubeModal() {
        var modal = YoutubeModal.__super__.constructor.call(this);
        var scope = this;
        $(this.Close)
            .on('click', function (e) {
                e.stopPropagation();
                e.preventDefault();
                var player = scope.GetPlayer();
                player.destroy();
            })
            .on('keydown', function (e) {
                if (e.key === 'Tab' & e.shiftKey) {
                    e.preventDefault();
                }
                else if (e.key === 'Enter') {
                    e.preventDefault();
                    $(this.Close).click();
                }
            })

        var application = HSN.Instance();
        application.Events.On(HSN.Application.EVENT.VIDEO_COMPLETE,
            function () {
                $('#closeModal').click();
            });

        return modal;
    }

    YoutubeModal.prototype._show = function(videoData, w, h, showDisclaimer) {
        var __scope = this;
        __scope.Root.removeClass("loading");
        __scope.Root.css("overflow-y", "hidden");
        //video div must have a unique id to allow multiple videos
        var playerId = "hsn-youtube-player";
        var disclaimer = (showDisclaimer) ? "<div id='video-disclaimer' style='padding: 0; margin: -15px 0 10px 24px'>Prices and the availability of FlexPay shown on the previously recorded video may not represent the current price options. Consult the product page for current price options.</div>" : "";
        var ada = "<div class='endOfModal' tabindex='0'></div>";
        this.Content.showHtml(
            "<div id=\"" + playerId + "\" style=\"width: " + w + "px; height: " + h + "px; display: block; padding: 23px;\"></div>" + disclaimer + ada, 0,
            function() {
                __scope.Center();
                __scope.Content.animate({ opacity: 1 },
                    {
                        complete: function () {
                            __scope.Close[0].focus();

                            $('.endOfModal', __scope.Root)
                                .off('focus')
                                .on('focus', function (e) {
                                    __scope.Close[0].focus();
                                    e.preventDefault();
                                })
                                .off('keydown')
                                .on('keydown', function (e) {
                                    __scope.Close[0].focus();
                                    e.preventDefault();
                                });

                        }
                    });

                //load player
                youtubePlayer = new YoutubePlayer(videoData);
            }
        );
    };

    YoutubeModal.prototype.GetPlayer = function () {
        return youtubePlayer;
    }

    return YoutubeModal;
})(HSN.Modal);



// WEBPACK FOOTER //
// ./assets/js/HSN/YoutubeModal.js